// Test rackets, loans and goods out without a sale (task 1.10b, D-040).
export const tenaxRacketsEnglishMessages = {
  tenax: {
    rackets: {
      title: "Test rackets",
      scan: "Barcode",
      new: "New racket",
      new_hint:
        "A racket taken off sale: the CRM gives it the next code and records the goods out.",
      created: "Racket created",
      returned: "Racket back in the house",
      all: "All",
      empty: "No test racket yet.",
      dashboard: "Rackets by model and status",
      unknown_code: "No test racket with code %{code}",
      overdue: "Overdue",
      days: "%{smart_count} day |||| %{smart_count} days",
      held_by: "With",
      current_loan: "Current loan",
      history: "History",
      no_history: "No movement yet.",
      print_label: "Print label",
      loans: "Test racket loans",
      loan_of: "Loan of %{day}",
      lent_on: "lent on %{day}",
      closed_on: "closed on %{day}",
      need_holder: "Choose a person or an organization",
      no_referral_code:
        "This holder has no active discount code: a purchase after the trial would not be attributed.",
      fields: {
        model: "Model",
        model_free: "Model (if not in the catalog)",
        variant_id: "Product variant",
        status: "Status",
        condition: "Condition",
        photo: "Photo",
        contact_id: "Person",
        company_id: "Organization",
        purpose_id: "Purpose",
        lent_at: "Lent on",
        expected_return_at: "Expected return",
        outcome: "Outcome",
        note: "Note",
        note_required: "Note (required)",
      },
      status: {
        in_house: "In the house",
        on_loan: "On loan",
        maintenance: "Maintenance",
        lost: "Lost",
        retired: "Retired",
      },
      kind: {
        delivery: "Delivery",
        return: "Return",
        transfer: "Transfer",
        status_change: "Status change",
        correction: "Correction",
      },
      outcome: {
        converted: "Converted",
        returned: "Returned",
        lost: "Lost",
        saved: "Outcome saved",
      },
      lend: {
        button: "Lend rackets",
        title: "Lend test rackets",
        hint: "Shoot the codes, or pick the rackets in the house from the list.",
        pick: "Pick by hand",
        picked: "Rackets to lend",
        not_in_house: "%{code} is not a test racket in the house",
        move_deal: 'Move the deal to "Prova inviata"',
        confirm: "Lend %{smart_count} racket |||| Lend %{smart_count} rackets",
        done: "Loan recorded",
      },
      actions: {
        return: "Return",
        transfer: "Transfer",
        transfer_hint:
          "From the holder to another, without coming back to the house.",
        status: "Change status",
        status_hint: "Maintenance, lost, retired or back in the house.",
        correction: "Correction",
        correction_hint:
          "When the CRM and reality are apart (a delivery never recorded, a wrong import): any status, any holder. It stays in the history.",
        need_note: "A correction needs a note",
        done: "Movement recorded",
      },
      signals: {
        overdue:
          "%{code} not back after %{smart_count} day |||| %{code} not back after %{smart_count} days",
      },
      conversion: {
        title: "Conversion of the trials",
        empty: "No trial yet.",
        month: "Month",
        loans: "Trials",
        converted: "Converted",
        returned: "Returned",
        lost: "Lost",
        open: "Open",
        conversion_pct: "On the outcomes",
        conversion_all_pct: "On all",
      },
      goods_outs: {
        title: "Goods out without a sale",
        new: "New goods out",
        empty: "No goods out yet.",
        reason: "Reason",
        description: "Description",
        qty: "Quantity",
        unit_cost: "Unit cost (€)",
        saved: "Goods out recorded",
      },
      labels: {
        button: "Print labels",
        title: "Print labels",
        hint: "Several labels on the same A4 sheet (%{columns} × %{rows}): tick the rackets or shoot their codes.",
        start_cell: "Starting cell (1–%{cells}, left to right, top to bottom)",
        chosen:
          "%{smart_count} racket chosen |||| %{smart_count} rackets chosen",
        all: "All",
        none: "None",
        list: "Rackets",
        print: "Print %{smart_count} label |||| Print %{smart_count} labels",
      },
      catalog: {
        title: "Purposes and reasons",
        purposes: "Loan purposes",
        reasons: "Goods out reasons",
        tracks_outcome: "Tracks the outcome",
        needs_recipient: "Needs a recipient",
        active: "Active",
        name: "Name",
        new: "New",
      },
    },
  },
};

export const tenaxRacketsItalianMessages = {
  tenax: {
    rackets: {
      title: "Racchette test",
      scan: "Codice a barre",
      new: "Nuova racchetta",
      new_hint:
        "Una racchetta tolta dalla vendita: il CRM le dà il codice successivo e registra l'uscita.",
      created: "Racchetta creata",
      returned: "Racchetta rientrata in sede",
      all: "Tutte",
      empty: "Ancora nessuna racchetta test.",
      dashboard: "Racchette per modello e stato",
      unknown_code: "Nessuna racchetta test con codice %{code}",
      overdue: "Rientro scaduto",
      days: "%{smart_count} giorno |||| %{smart_count} giorni",
      held_by: "Presso",
      current_loan: "Prestito in corso",
      history: "Storico",
      no_history: "Ancora nessun movimento.",
      print_label: "Stampa etichetta",
      loans: "Prestiti di racchette test",
      loan_of: "Prestito del %{day}",
      lent_on: "prestato il %{day}",
      closed_on: "chiuso il %{day}",
      need_holder: "Scegli una persona o un'organizzazione",
      no_referral_code:
        "Questo detentore non ha un codice sconto attivo: un acquisto dopo la prova non verrebbe attribuito.",
      fields: {
        model: "Modello",
        model_free: "Modello (se non è a catalogo)",
        variant_id: "Variante di prodotto",
        status: "Stato",
        condition: "Condizioni",
        photo: "Foto",
        contact_id: "Persona",
        company_id: "Organizzazione",
        purpose_id: "Scopo",
        lent_at: "Prestata il",
        expected_return_at: "Rientro previsto",
        outcome: "Esito",
        note: "Nota",
        note_required: "Nota (obbligatoria)",
      },
      status: {
        in_house: "In sede",
        on_loan: "In prestito",
        maintenance: "In manutenzione",
        lost: "Persa",
        retired: "Dismessa",
      },
      kind: {
        delivery: "Consegna",
        return: "Rientro",
        transfer: "Passaggio",
        status_change: "Cambio stato",
        correction: "Rettifica",
      },
      outcome: {
        converted: "Convertita",
        returned: "Restituita",
        lost: "Persa",
        saved: "Esito registrato",
      },
      lend: {
        button: "Presta racchette",
        title: "Presta racchette test",
        hint: "Spara i codici, oppure scegli dall'elenco le racchette in sede.",
        pick: "Scelta a mano",
        picked: "Racchette da prestare",
        not_in_house: "%{code} non è una racchetta test in sede",
        move_deal: "Sposta la trattativa in «Prova inviata»",
        confirm:
          "Presta %{smart_count} racchetta |||| Presta %{smart_count} racchette",
        done: "Prestito registrato",
      },
      actions: {
        return: "Rientro",
        transfer: "Passaggio",
        transfer_hint: "Dal detentore a un altro, senza passare dalla sede.",
        status: "Cambia stato",
        status_hint: "Manutenzione, persa, dismessa o di nuovo in sede.",
        correction: "Rettifica",
        correction_hint:
          "Quando CRM e realtà non coincidono (consegna mai registrata, import sbagliato): qualunque stato, qualunque detentore. Resta nello storico.",
        need_note: "La rettifica vuole una nota",
        done: "Movimento registrato",
      },
      signals: {
        overdue:
          "%{code} non rientrata da %{smart_count} giorno |||| %{code} non rientrata da %{smart_count} giorni",
      },
      conversion: {
        title: "Conversione delle prove",
        empty: "Ancora nessuna prova.",
        month: "Mese",
        loans: "Prove",
        converted: "Convertite",
        returned: "Restituite",
        lost: "Perse",
        open: "Aperte",
        conversion_pct: "Sugli esiti",
        conversion_all_pct: "Su tutte",
      },
      goods_outs: {
        title: "Uscite senza vendita",
        new: "Nuova uscita",
        empty: "Ancora nessuna uscita.",
        reason: "Causale",
        description: "Descrizione",
        qty: "Quantità",
        unit_cost: "Costo unitario (€)",
        saved: "Uscita registrata",
      },
      labels: {
        button: "Stampa etichette",
        title: "Stampa etichette",
        hint: "Più etichette sullo stesso foglio A4 (%{columns} × %{rows}): spunta le racchette o spara i loro codici.",
        start_cell:
          "Casella di partenza (1–%{cells}, da sinistra a destra, dall'alto in basso)",
        chosen:
          "%{smart_count} racchetta scelta |||| %{smart_count} racchette scelte",
        all: "Tutte",
        none: "Nessuna",
        list: "Racchette",
        print:
          "Stampa %{smart_count} etichetta |||| Stampa %{smart_count} etichette",
      },
      catalog: {
        title: "Scopi e causali",
        purposes: "Scopi dei prestiti",
        reasons: "Causali delle uscite",
        tracks_outcome: "Segue l'esito",
        needs_recipient: "Vuole un destinatario",
        active: "Attivo",
        name: "Nome",
        new: "Nuovo",
      },
    },
  },
};
